interface CacheItem<T> {
    value: T;
    time: EpochTimeStamp;
    ttl: number;
}

export class SimpleCache<K, V> {
    cache: Map<K, CacheItem<V>> = new Map();

    // get takes a key and promise and returns either the cached result or awaits the promise
    // this effectively optimistically executes the promise in the background while we determine if the promise is needed
    async get(key: K, fetchPromise: Promise<V>, ttlMs: number): Promise<V> {
        const now = Date.now();
        const cached = this.cache.get(key);

        if (cached && (now - cached.time < cached.ttl)) {
            return cached.value;
        }

        const value = await fetchPromise;
        this.cache.set(key, { value, time: now, ttl: ttlMs });
        return value;
    }
}